import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '@/lib/firebase';

/** @readonly */
export const ARTIST_ANALYTICS_EVENT_TYPES = {
  /** In-app “First time going live?” walkthrough finished (LiveDashboard trial demo). */
  LIVE_TRIAL_DEMO_COMPLETED: 'live_trial_demo_completed',
};

/**
 * Append-only product analytics for artists (Admin Console → Analytics).
 */
export async function recordArtistAnalyticsEvent(user, options = {}) {
  if (!db || !user?.uid) return;
  const eventType = options.eventType;
  if (!eventType || !Object.values(ARTIST_ANALYTICS_EVENT_TYPES).includes(eventType)) {
    console.warn('recordArtistAnalyticsEvent: invalid eventType', eventType);
    return;
  }
  try {
    const row = {
      user_id: user.uid,
      email: user.email || null,
      event_type: eventType,
      created_at: serverTimestamp(),
    };
    if (options.sourcePath) {
      row.source_path = String(options.sourcePath).slice(0, 500);
    }
    await addDoc(collection(db, 'artist_analytics_events'), row);
  } catch (e) {
    console.warn('recordArtistAnalyticsEvent:', e?.code || e?.message || e);
  }
}
